angular.module('impactx.catalog').controller('CatalogContractDialogController', [
    '$scope',
    'dataGen',
    'TranslationService',
    '$mdDialog',
    '$redirect',
    CatalogContractDialogCtrl]);

function CatalogContractDialogCtrl($scope, dataGen, TranslationService, $mdDialog, $redirect) {
    var self = this;

    dataGen.getData($scope, {id: self.catId}, "/catalog/catalogcontractrelation").then(function() {
        $scope.trns.back = TranslationService.get('back');
    });

    self.closeDialog = function() {
        $mdDialog.hide();
    };

    self.jumpToContract = function (contractId) {
        $mdDialog.hide();
        $redirect.redirectTo(null, "/cscontractlist/" + contractId);
    };

}